import Modal from 'components/Modal'
import React from 'react'

/**
 * @param onClose
 * @param children
 * @returns {Element}
 * @constructor
 */
export default function BlankModal ({
  onClose,
  children
}) {
  return (
    <Modal
      onClose={onClose}
      adjustToContentHeight
    >
      {children}
    </Modal>
  )
}
